import { Form } from 'app/components/form/form';
import { Validators } from '@angular/forms';

export class BillingForm extends Form {

  formErrors = {
    'name': {},
    'address': {},
    'phone': {},
  };

  getInitForm = (name?: String, phone?: String, address?: String) => {
    return {
      'name': [name, [
        Validators.required,
        Validators.pattern(this.validatePattern.billingName)
      ]],
      'address': [address, [
        Validators.required,
        Validators.pattern(this.validatePattern.billingAddress)
      ]],
      'phone': [phone, [
        Validators.required,
        Validators.pattern(this.validatePattern.phone)
      ]]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/components/billing-address/billing-form/billing.form.ts